<template>
    <section class="container">

        <div id="map">
            <lmarker v-if="sharedState.fetched.markerLegends"></lmarker>
            <vlayer ref="vlayer"></vlayer>
        </div>
        <!-- <div id="overlaycontents" v-show="showContents">
            <div id="contents">
                <p>testtetsttestes</p>
                <linfoWindow></linfoWindow>
                <button v-on:click="closeContents">Close</button>
            </div>
        </div> -->
    </section>

</template>

<script>
    import _env from '../../config/dev.env.var.js';
    import L from 'leaflet';
    import "../../node_modules/leaflet/dist/leaflet.css";
    import axios from 'axios'
    import lmarker from '@/components/marker';
    import vlayer from '@/components/vectorTileLayer';
    // import linfoWindow from '@/components/infoWindow'


    export default {
        name: 'Map',
        components:{
            vlayer,
            lmarker
        },
        data () {
            return {
                showContents:false,
                cityName: 'kurashiki',
            }
        },
        async created () {
            this.setBrowserType()
            this.setUid()
            await this.fetchConfig()
              .then(async ()=> {
                // クエリからcityCodeを引く
                this.setCityCodes()
                // 表示する市区町村用の THRESHOLD をセット
                this.$store.commit('setThreshold', this.cityName);
                
                // 参照サイト凡例を取得
                this.initMap()
                await this.$store.dispatch('fetchMarkerLegends')
                  .catch(error => {
                    console.log(error)
                    console.log("marker-legends を取得できませんでした。");
                  })
              })
            // await this.fetchMeshOgaInit()
            // .then(()=>{
            //     // this.renderMeshOga()
            //     this.renderChoMeshOga()
            //     this.$store.commit('chgLoadingModalVisible', false)
            // })
            // await this.fetchMeshOgaRest()
        },
        mounted () {
        },
        computed: {
            sharedState () {
                return this.$store.state
            },
            threshold () {
                return this.sharedState.thresholds
            },
            config () {
                return this.sharedState.config_from_api
            },
            hash2cityTable () {
                return this.config.hash2cityTable
            },
            year () {
                return this.sharedState.year
            },
            selectedLayer(){
                return this.sharedState.selectedLayer
            },
            cityCode(){
                return this.sharedState.cityCode
            },
            showOsm(){
                return this.sharedState.showOsm
            }
        },
        watch: {
        },
        methods: {
            openContents(){
                this.showContents=true
           },
            closeContents(){
                this.showContents=false
           },
            async fetchConfig () {
              await this.$store.commit('setUrlParams')
              await this.$store.dispatch('fetchConfig')
            },

            initMap () {
                this.drawMap()
                // store 側で境界データとメッシュデータをapiで取得し，stateに保存する処理を先に済ませてからそれぞれの描画を行う．
                // ロード画面の表示
                this.$store.commit('chgLoadingModalVisible', true)
                this.$refs.vlayer.updateLayerChain()
                Promise.all([this.setBoundaries()])
                .then(() => {
                    this.renderBoundaries();
                });
            },
            drawMap () {
                const thisCityConfig = this.config.cityConfig;

                const map = L.map('map', {
                    center: [thisCityConfig.center.lat, thisCityConfig.center.lng],
                    zoom: thisCityConfig.zoom,
                    gestureHandling: true,
                    preferCanvas: true,
                    scrollWheelZoom: false
                }).on('click', (e) => this.$store.commit('setMapClickEvent', e));
                map.on('resize', () => this.$store.commit('setMapChangeEvent'))
                map.on('zoomend', () => this.$store.commit('setMapChangeEvent'))
                map.on('moveend', () => this.$store.commit('setMapChangeEvent'))
                const mapObj = document.getElementById('map')
                mapObj.addEventListener("focus", () => {map.scrollWheelZoom.enable()});
                mapObj.addEventListener("blur", () => {map.scrollWheelZoom.disable()});

                this.$store.commit('setMap', map)

                const osmtile = L.tileLayer('//{s}.tile.osm.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="//osm.org/copyright">OpenStreetMap</a> contributors'
                })
                const gsistdtile = L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/std/{z}/{x}/{y}.png', {
                    attribution: "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>"
                })
                const gsiorttile = L.tileLayer('https://cyberjapandata.gsi.go.jp/xyz/ort/{z}/{x}/{y}.jpg', {
                    attribution: "<a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>地理院タイル</a>"
                })


                // OpenStreetMap は既定では非表示とし，GETパラメータ osm が指定された場合のみ
                // 背景地図の候補に加え，初期表示にも採用する．
                const baseLayers = {}
                if (this.showOsm) {
                    baseLayers["OpenStreetMap"] = osmtile
                }
                baseLayers["国土地理院-標準地図"] = gsistdtile
                baseLayers["国土地理院-空中写真・衛星画像"] = gsiorttile

                if (this.showOsm) {
                    osmtile.addTo(map)
                } else {
                    gsistdtile.addTo(map)
                }

                const Lcontrol = L.control.layers(baseLayers)
                this.$store.commit('addLayer', Lcontrol)

            },      
            async setBoundaries () {
                await axios.get(`${_env.localAPI}/boundaries`)
                .then(res => {
                    this.$store.commit('setBoundaries', res)
                })
                .catch(error => {
                    console.log(error)
                    console.log("boundaries.topojson を取得できませんでした．");
                });
            },
            renderBoundaries () {
                const geo = L.geoJSON(this.sharedState.geometry.boundaries, {
                    style: {
                        fillColor: 'none', // 境界線のみを描画するため，内側を無色にする．
                        color: '#00a795',
                        weight: 2
                    },
                    renderer: L.svg()
                })
                this.$store.commit('addLayer', geo)
            },
            setBrowserType () {
                this.$store.commit('setBrowserType');
            },
            setCityCodes () {
                const queryJson = this.$route.query;
                const queryLen = Object.keys(queryJson).length;
                // クエリにcityがあるかどうか
                const cityCode = queryJson.city || this.sharedState.cityCode
                if (cityCode) {
                    this.$store.commit('setCityCodes', cityCode);
                    this.cityName = this.config.cityName
                } else {
                    console.log('クエリでcityが指定されていません。')
                }
            },
            setUid () {
                const queryJson = this.$route.query;
                const queryLen = Object.keys(queryJson).length;
                // クエリにuidがあるかどうか
                const uid = queryJson.uid || this.sharedState.uid
                if (uid) {
                    this.$store.commit('setUid', uid);
                } else {
                    console.log('クエリでuidが指定されていません。')
                }
            },
      }
    }
</script>

<style scoped>
#map {
  height: 100%;
  width: 100%;
  margin: auto;
}

#overlaycontents {
    /*　要素を重ねた時の順番　*/ 
    z-index:1000;

    /*　画面全体を覆う設定　*/
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background-color:rgba(0,0,0,0.5);

    /*　画面の中央に要素を表示させる設定　*/
    display: flex;
    align-items: center;
    justify-content: center;

}

</style>
